import React from 'react';
import { connect } from 'react-redux';
import {
    DEBATE_GAME_SCREEN,
    END_OF_DAY_SCREEN,
    GAME_SETTINGS_SCREEN,
    INQUIRY_GAME_SCREEN,
    MAIN_GAME_SCREEN,
    MEETINGS_GAME_SCREEN,
    MESSAGES_GAME_SCREEN,
    QUESTIONS_GAME_SCREEN,
    PRESS_GAME_SCREEN,
    QUICKPLAY_SCREEN,
    SETTINGS_SCREEN,
    START_OF_DAY_SCREEN,
    TITLE_SCREEN,
    VOTE_GAME_SCREEN,
    WELCOME_LETTER_SCREEN,
    TIME_PASSING_SCREEN,
} from './constants/routes';
import { TitleScreen } from './screens/title-screen/index';
import { GameSettingsScreen } from './screens/game-settings-screen';
import { WelcomeLetterScreen } from './screens/welcome-letter-screen';
import { MainGameScreen } from './screens/main-game-screen';
import { MessagesGameScreen } from './screens/messages-game-screen';
import { PressGameScreen } from './screens/press-game-screen';
import { MeetingsGameScreen } from './screens/meetings-game-screen';
import { DebateGameScreen } from './screens/debate-game-screen';
import { InquiryGameScreen } from './screens/inquiry-game-screen';
import { SettingsScreen } from './screens/settings-screen';
import { QuickplayScreen } from './screens/quickplay-screen';
import { PMQsGameScreen } from './screens/questions-game-screen';
import { VoteGameScreen } from './screens/vote-game-screen';
import { EndOfDayScreen } from './screens/end-of-day-screen';
import { StartOfDayScreen } from './screens/start-of-day-screen';
import { TimePassingScreen } from './screens/time-passing-screen';
import { Background } from './components/background';

const ScreenRouter = props => {
    const { currentRoute, fontSize } = props;

    return (
        <Background page={currentRoute} fontSize={fontSize}>
            {(() => {
                switch (currentRoute) {
                    case TITLE_SCREEN:
                        return <TitleScreen />;
                    case GAME_SETTINGS_SCREEN:
                        return <GameSettingsScreen />;
                    case WELCOME_LETTER_SCREEN:
                        return <WelcomeLetterScreen />;
                    case MAIN_GAME_SCREEN:
                        return <MainGameScreen />;
                    case MESSAGES_GAME_SCREEN:
                        return <MessagesGameScreen />;
                    case PRESS_GAME_SCREEN:
                        return <PressGameScreen />;
                    case MEETINGS_GAME_SCREEN:
                        return <MeetingsGameScreen />;
                    case DEBATE_GAME_SCREEN:
                        return <DebateGameScreen />;
                    case INQUIRY_GAME_SCREEN:
                        return <InquiryGameScreen />;
                    case SETTINGS_SCREEN:
                        return <SettingsScreen />;
                    case QUICKPLAY_SCREEN:
                        return <QuickplayScreen />;
                    case QUESTIONS_GAME_SCREEN:
                        return <PMQsGameScreen />;
                    case VOTE_GAME_SCREEN:
                        return <VoteGameScreen />;
                    case TIME_PASSING_SCREEN:
                        return <TimePassingScreen />;
                    case END_OF_DAY_SCREEN:
                        return <EndOfDayScreen />;
                    case START_OF_DAY_SCREEN:
                        return <StartOfDayScreen />;
                    default:
                        return <TitleScreen />;
                }
            })()}
        </Background>
    );
};

const mapStateToProps = state => {
    return {
        currentRoute: state.router.currentRoute,
        fontSize: state.settings.accessibility.fontSize,
    };
};

export default connect(mapStateToProps)(ScreenRouter);
